module.exports = __webpack_public_path__ + "static/media/wizualizacja-12.95c1efa6.png";